import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70b21a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-image-container container1" }
const _hoisted_2 = { class: "span1 span1-ani" }
const _hoisted_3 = { class: "sub-span" }
const _hoisted_4 = { class: "carousel-image-container container2" }
const _hoisted_5 = {
  "data-wow-delay": "1s",
  class: "span2"
}
const _hoisted_6 = { class: "sub-span" }
const _hoisted_7 = { class: "carousel-image-container container3" }
const _hoisted_8 = {
  "data-wow-delay": "1s",
  class: "span3"
}
const _hoisted_9 = { class: "banner3text" }
const _hoisted_10 = { class: "sub-span" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerView',
  setup(__props) {


onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})
const handleCarouselChange = (e) => {
  if (e === 0) {
    const element1 = document.getElementsByClassName('logo1')
    const elementsArray1 = Array.from(element1)
    elementsArray1.forEach((element) => {
      element.classList.add('b1-float2-ani')
    })
    const element2 = document.getElementsByClassName('span1')
    const elementsArray2 = Array.from(element2)
    elementsArray2.forEach((element) => {
      element.classList.add('span1-ani')
    })
    const element3 = document.getElementsByClassName('span2')
    const elementsArray3 = Array.from(element3)
    elementsArray3.forEach((element) => {
      element.classList.remove('span2-ani')
    })

    const element4 = document.getElementsByClassName('logo0')
    const elementsArray4 = Array.from(element4)
    elementsArray4.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element5 = document.getElementsByClassName('left-center')
    const elementsArray5 = Array.from(element5)
    elementsArray5.forEach((element) => {
      element.classList.remove('span1-ani')
    })
    const spans = ['span3', 'span4']
    for (let i = 0; i < spans.length; i++) {
      const element = document.getElementsByClassName(spans[i])
      const elementsArray = Array.from(element)
      elementsArray.forEach((element) => {
        element.classList.remove('span1-ani')
      })
    }
  } else if (e === 1) {
    const element1 = document.getElementsByClassName('span2')
    const elementsArray1 = Array.from(element1)
    elementsArray1.forEach((element) => {
      element.classList.add('span2-ani')
    })
    const element2 = document.getElementsByClassName('logo1')
    const elementsArray2 = Array.from(element2)
    elementsArray2.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element4 = document.getElementsByClassName('logo0')
    const elementsArray4 = Array.from(element4)
    elementsArray4.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element5 = document.getElementsByClassName('left-center')
    const elementsArray5 = Array.from(element5)
    elementsArray5.forEach((element) => {
      element.classList.remove('span1-ani')
    })
    const spans = ['span1', 'span3', 'span4']
    for (let i = 0; i < spans.length; i++) {
      const element = document.getElementsByClassName(spans[i])
      const elementsArray = Array.from(element)
      elementsArray.forEach((element) => {
        element.classList.remove('span1-ani')
      })
    }
  } else if (e === 2) {
    const element1 = document.getElementsByClassName('span3')
    const elementsArray1 = Array.from(element1)
    elementsArray1.forEach((element) => {
      element.classList.add('span1-ani')
    })
    const element2 = document.getElementsByClassName('logo1')
    const elementsArray2 = Array.from(element2)
    elementsArray2.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element3 = document.getElementsByClassName('span2')
    const elementsArray3 = Array.from(element3)
    elementsArray3.forEach((element) => {
      element.classList.remove('span2-ani')
    })
    const element4 = document.getElementsByClassName('logo0')
    const elementsArray4 = Array.from(element4)
    elementsArray4.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element5 = document.getElementsByClassName('left-center')
    const elementsArray5 = Array.from(element5)
    elementsArray5.forEach((element) => {
      element.classList.remove('span1-ani')
    })
    const spans = ['span1', 'span4']
    for (let i = 0; i < spans.length; i++) {
      const element = document.getElementsByClassName(spans[i])
      const elementsArray = Array.from(element)
      elementsArray.forEach((element) => {
        element.classList.remove('span1-ani')
      })
    }
  } else if (e === 3) {
    const element1 = document.getElementsByClassName('span4')
    const elementsArray1 = Array.from(element1)
    elementsArray1.forEach((element) => {
      element.classList.add('span1-ani')
    })
    const element2 = document.getElementsByClassName('logo1')
    const elementsArray2 = Array.from(element2)
    elementsArray2.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element3 = document.getElementsByClassName('span2')
    const elementsArray3 = Array.from(element3)
    elementsArray3.forEach((element) => {
      element.classList.remove('span2-ani')
    })
    const element4 = document.getElementsByClassName('logo0')
    const elementsArray4 = Array.from(element4)
    elementsArray4.forEach((element) => {
      element.classList.remove('b1-float2-ani')
    })
    const element5 = document.getElementsByClassName('left-center')
    const elementsArray5 = Array.from(element5)
    elementsArray5.forEach((element) => {
      element.classList.remove('span1-ani')
    })
    const spans = ['span1', 'span3']
    for (let i = 0; i < spans.length; i++) {
      const element = document.getElementsByClassName(spans[i])
      const elementsArray = Array.from(element)
      elementsArray.forEach((element) => {
        element.classList.remove('span1-ani')
      })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_carousel, {
      class: "carousel-container",
      autoplay: true,
      onChange: handleCarouselChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_carousel_item, { class: "carousel-slide" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('banner1text')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('banner1text1')), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('banner1text2')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, { class: "carousel-slide" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('banner2text')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('banner2text1')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('banner2text2')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, { class: "carousel-slide" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('banner3title')), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('banner3text')), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('banner3text3')), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})